export const SPLATFileLoaderMetadata = {
    name: "splat",
    extensions: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".splat": { isBinary: true },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".ply": { isBinary: true },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".spz": { isBinary: true },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".json": { isBinary: false }, // For SOG metadata files
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".sog": { isBinary: true },
    },
};
//# sourceMappingURL=splatFileLoader.metadata.js.map